import { keyframes, styled } from "styled-components";
import GenericBlurredOverlay from "../GenericBlurredOverlay/GenericBlurredOverlay";
import { Container } from "../../styledComponents/Container/Container";
import { NavButton } from "../NavButton/NavButton";
import { Reoverlay } from "reoverlay";
import { GlassmorphismContainer } from "../GlassmorphismContainer/GlassmorphismContainer";
import { useAppSelector } from "../../store/hooks";
import { CONTRAST_ENUM } from "../../pages/SettingsPage/constants/constants";

const MODAL_SIZE = {
  sm: 20,
  md: 30,
  lg: 40,
  xl: 50,
};

const getModalSize = (
  size: "sm" | "md" | "lg" | "xl",
  isWidth: boolean,
): string => {
  return MODAL_SIZE[size] + (isWidth ? 10 : 0) + "rem";
};

const slideDownFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const GenericModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100dvw;
  height: 100svh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;
  padding: 1rem;

  animation: ${slideDownFadeIn} 0.3s ease forwards;
`;

interface GenericModalProps {
  children: JSX.Element;
  size: "sm" | "md" | "lg" | "xl";
  overrideHeader?: JSX.Element;
  onCancel?: () => void;
}

const GenericModal = (props: GenericModalProps): JSX.Element => {
  const { children, size, overrideHeader, onCancel } = props;

  const contrast = useAppSelector((state) => state.userInfo.contrast);

  return (
    <GenericBlurredOverlay>
      <GenericModalWrapper>
        <GlassmorphismContainer
          height={getModalSize(size, false)}
          width={getModalSize(size, true)}
          borderRadius="2rem"
          hasBorder
          padding="1rem"
          contrast={contrast}
        >
          {overrideHeader ? (
            overrideHeader
          ) : (
            <Container
              alignItems="flex-start"
              justifyContent="flex-end"
              width="100%"
            >
              <NavButton
                onClick={onCancel ? onCancel : () => Reoverlay.hideModal()}
                button="exit"
                variant={
                  contrast === CONTRAST_ENUM.WHITE ? "primary" : "secondary"
                }
              />
            </Container>
          )}
          {children}
        </GlassmorphismContainer>
      </GenericModalWrapper>
    </GenericBlurredOverlay>
  );
};

export default GenericModal;
